import { Theme, tooltipClasses } from '@mui/material'
import { blue, gray, uiColors } from '~/common/styles/colors'
import { typography } from '~/common/styles/typography'
import { TooltipPaddingSetting, TooltipType } from '../types'

const primaryTooltipPopperPrimitives = (paddingSetting: TooltipPaddingSetting, theme: Theme) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: paddingSetting === 'default' ? theme.spacing(0.75) : 0,
    color: uiColors.content.white,
    backgroundColor: gray[12],
    border: `1px solid ${gray[10]}`,
    borderRadius: '4px',
    maxWidth: '176px',
    ...typography.body1,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: uiColors.content.primary,
  },
})

const secondaryTooltipPopperPrimitives = (paddingSetting: TooltipPaddingSetting, theme: Theme) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: gray[10],
    padding: paddingSetting === 'default' ? theme.spacing(0.75) : 0,
    backgroundColor: gray[1],
    border: `1px solid ${gray[4]}`,
    borderRadius: '4px',
    maxWidth: '176px',
    ...typography.body1,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: gray[1],
  },
})

const actionTooltipPopperPrimitives = (paddingSetting: TooltipPaddingSetting, theme: Theme) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...typography.body1,
    padding: paddingSetting === 'default' ? theme.spacing(0.75) : 0,
    color: blue[1],
    backgroundColor: blue[9],
    borderRadius: '4px',
    maxWidth: '176px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: blue[9],
  },
  [`& a`]: {
    color: blue[1],
    textDecorationColor: blue[3],
    '&:hover': {
      textDecorationColor: uiColors.content.white,
    },
  },
})

export const getTooltipPopperPrimitives = (
  type: TooltipType,
  paddingSetting: TooltipPaddingSetting,
  theme: Theme,
) => {
  switch (type) {
    case 'primary':
      return primaryTooltipPopperPrimitives(paddingSetting, theme)
    case 'secondary':
      return secondaryTooltipPopperPrimitives(paddingSetting, theme)
    case 'action':
      return actionTooltipPopperPrimitives(paddingSetting, theme)
  }
}
